






import Vue from 'vue'
import { Component, Provide } from 'vue-property-decorator'

@Component
export default class Home extends Vue {
	public reloadFlag: boolean = true
	public layout = 'Layout'

	@Provide('reload')
	public reload: () => void = () => {
		this.reloadPage()
	}

	private reloadPage() {
		this.reloadFlag = false
		this.$nextTick(function() {
			this.reloadFlag = true
		})
	}

	public created() {
		document.title = this.$t('學生選課').toString()
	}
}
